import bugsnag from 'bugsnag-js'

function createClient () {
  if (typeof bugsnag !== 'function') {
    // bugsnag-js is browser only, and its node entry point exports
    // nothing. Unit tests run under Node, where there is nothing to
    // report to anyway, so hand back a client that swallows calls
    // instead of letting every importing module fail to load.
    return {
      notify () {},
      use () {}
    }
  }

  return bugsnag({
    apiKey: '3e1a3078dfd94a0e62835beb18b80df1',
    releaseStage: process.env.VUE_APP_BUGSNAG_RELEASE_STAGE,
    notifyReleaseStages: ['production', 'staging']
  })
}

const bugsnagClient = createClient()
export default bugsnagClient
